import i18n from '@/Config/app/i18n';

export const formatRelativeTime = (isoString: string): string => {
  const diffMs = Date.now() - new Date(isoString).getTime();
  const diffMinutes = Math.floor(diffMs / 60_000);
  const diffHours = Math.floor(diffMs / 3_600_000);
  const diffDays = Math.floor(diffMs / 86_400_000);

  if (diffMinutes < 1) return i18n.t('actions_page:stats.just_now');
  if (diffMinutes < 60) return i18n.t('actions_page:stats.minutes_ago', { count: diffMinutes });
  if (diffHours < 24) return i18n.t('actions_page:stats.hours_ago', { count: diffHours });
  return i18n.t('actions_page:stats.days_ago', { count: diffDays });
};
